module.exports = __webpack_public_path__ + "img/qr-code.b371e3d1.png";